import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { pathAfterLogin } from "@/lib/residences";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { googleSession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      if (sid) {
        try {
          await googleSession(sid);
          const dest = await pathAfterLogin("/");
          window.history.replaceState(null, "", "/");
          nav(dest, { replace: true });
        } catch {
          nav("/connexion", { replace: true });
        }
      } else {
        nav("/connexion", { replace: true });
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="text-center">
        <div className="w-12 h-12 rounded-full border-4 border-white/10 border-t-[#FF5A00] animate-spin mx-auto" />
        <p className="mt-4 text-slate-400">Connexion en cours...</p>
      </div>
    </div>
  );
}
